import { getGrowthIndex } from "./growIndexCalculator";

function roundToHundredth(number) {
    return Math.round(number*100) / 100;
}

function calcQualityPercentages(farmingLevel, qualityLevel) {
    // All quality calculations are based off of the formula for gold probability
    let goldChance = 0.2 * (farmingLevel / 10) + 0.2 * (qualityLevel) * ((farmingLevel + 2) / 12) + 0.01;
    let iridiumChance = 0;
    let silverChance = 0;
    let regularChance = 0;
    // Deluxe Fertilizer gets special treatment because it allows for Iridium quality and removes Regular quality entirely
    if (qualityLevel === 3) {
        iridiumChance = goldChance / 2;

        if (goldChance < 1) {
            goldChance *= (1 - iridiumChance);
            silverChance = 1 - iridiumChance - goldChance;
        } else {
            let iridiumGoldChancesSum = iridiumChance + goldChance;
            goldChance -= (iridiumGoldChancesSum-1);
        }
        
    } else {
        // Special equation for Silver quality due to how probablility works with the gold chance applied first.
        silverChance = (1 - goldChance) * Math.min(0.75, 2*goldChance);
        let goldSilverChancesSum = goldChance + silverChance;
        if (goldSilverChancesSum > 1) {
            silverChance -= (goldSilverChancesSum-1);
        } else {
            regularChance = 1 - goldChance - silverChance;
        }
    }

    // TODO? - Make quality percentages reflect the harvestYield weirdness, where only one of the multiple drops can have a quality higher than normal

    // Percentages go regular, silver, gold, iridium 
    return [roundToHundredth(regularChance), roundToHundredth(silverChance), roundToHundredth(goldChance), roundToHundredth(iridiumChance)];
}

function calcAvgPriceMultiplierFromQualityPercentages([regularChance, silverChance, goldChance, iridiumChance]) {
    let priceMultiplier = regularChance * 1 + silverChance * 1.25 + goldChance * 1.5 + iridiumChance * 2;
    return roundToHundredth(priceMultiplier); 
}

export function calcHarvestResults(crop, plantNumber, fertilizer, tillerSelected, agSelected, farmingLevel) {
    let value = crop.cropValue;
    let seedCost = crop.seedCost;
    let fertilizerCost = fertilizer.bestPrice;
    let harvestYield = crop.harvestYield;

    let growIndex = getGrowthIndex(fertilizer.speedGroLevel ? fertilizer.speedGroLevel : 0, agSelected);
    let qualityLevel = fertilizer.qualityLevel ? fertilizer.qualityLevel : 0;
    let qualityPercentages = calcQualityPercentages(farmingLevel, qualityLevel)
    let avgPriceMultiplier = calcAvgPriceMultiplierFromQualityPercentages(qualityPercentages);

    let growTime = crop.growTime[growIndex];
    let totalYield = plantNumber * harvestYield;
    let totalProfit;

    // Must check for multi-harvest crop, as quality fertilizers only affect one of the crops produced
    if (harvestYield > 1) {
        //totalProfit = plantNumber*value*avgPriceMultiplier + (harvestYield-1)*plantNumber*value;
        // This ^ first equation worked, but after a while of thinking and doing the math, this second one works cleaner and the math turns out the same, letting me get rid of the else statement
        avgPriceMultiplier = (avgPriceMultiplier + (harvestYield-1)) / harvestYield
    } 

    totalProfit = totalYield*value*avgPriceMultiplier;

    if (tillerSelected === true) {
        totalProfit *= 1.1;
    } 
    
    let profitPerDay = totalProfit / growTime;
    let totalCost = (seedCost + fertilizerCost) * plantNumber

    let netProfit = totalProfit - totalCost;

    let netProfitPerDay = netProfit / growTime;

    let isRegrowCrop = crop.regrowTime ? true : false;

    let response = {
        totalProfit : totalProfit.toFixed(2),
        profitPerDay : profitPerDay.toFixed(2),
        growTime : growTime,
        totalYield : totalYield,
        seedCost : seedCost*plantNumber,
        fertilizerCost : fertilizerCost*plantNumber,
        totalCost : totalCost,
        netProfit : netProfit.toFixed(2),
        netProfitPerDay : netProfitPerDay.toFixed(2),
        qualityPercentages : qualityPercentages,
        avgPriceMultiplier : roundToHundredth(avgPriceMultiplier),
        cropImgLink : crop.imgLink,
        fertilizerImgLink : fertilizer.imgLink,
        isRegrowCrop: isRegrowCrop
    }
    console.log("Response from calcHarvestResults: ", response);
    return response;
}

export function calcRegrowResults(crop, plantNumber, tillerSelected, fertilizer, farmingLevel) {
    let value = crop.cropValue;
    let harvestYield = crop.harvestYield;

    let regrowTime = crop.regrowTime;
    let qualityLevel = fertilizer.qualityLevel ? fertilizer.qualityLevel : 0;
    let qualityPercentages = calcQualityPercentages(farmingLevel, qualityLevel)
    let avgPriceMultiplier = calcAvgPriceMultiplierFromQualityPercentages(qualityPercentages);

    let regrowYield = plantNumber * harvestYield
    let regrowProfit;

    if (harvestYield > 1 && qualityLevel !== 0) {
        regrowProfit = plantNumber*value*avgPriceMultiplier + (harvestYield-1)*plantNumber*value;
    } else {
        regrowProfit = plantNumber*value*avgPriceMultiplier;
    }

    if (tillerSelected === true) {
        regrowProfit *= 1.1;
    } 
    
    let regrowProfitPerDay = regrowProfit / regrowTime;

    let response = {
        regrowProfit : regrowProfit.toFixed(2),
        regrowProfitPerDay : regrowProfitPerDay.toFixed(2),
        regrowTime : regrowTime,
        regrowYield : regrowYield,
        imgLink : crop.imgLink
    }
    console.log("Response from calcRegrowResults: ", response);
    return response;
}
